import type { HospitalStaffMember } from "./types";

/** Jeu de secours — présentation hospitalière si API RH indisponible ou droits manquants. */
export const DEMO_HOSPITAL_STAFF: HospitalStaffMember[] = [
  {
    id: "demo-staff-1",
    firstName: "Amina",
    lastName: "Kabongo",
    email: "amina.kabongo@hospitol.demo",
    department: "Urgences",
    position: "Infirmière chef",
    status: "ACTIVE",
  },
  {
    id: "demo-staff-2",
    firstName: "Patrick",
    lastName: "Mbuyi",
    email: "patrick.mbuyi@hospitol.demo",
    department: "Médecine générale",
    position: "Médecin généraliste",
    status: "ACTIVE",
  },
  {
    id: "demo-staff-3",
    firstName: "Grace",
    lastName: "Ilunga",
    email: "grace.ilunga@hospitol.demo",
    department: "Pharmacie",
    position: "Pharmacien responsable",
    status: "ACTIVE",
  },
  {
    id: "demo-staff-4",
    firstName: "Joseph",
    lastName: "Tshilombo",
    email: "joseph.tshilombo@hospitol.demo",
    department: "Laboratoire",
    position: "Technicien labo",
    status: "ACTIVE",
  },
  {
    id: "demo-staff-5",
    firstName: "Sarah",
    lastName: "Mutombo",
    email: "sarah.mutombo@hospitol.demo",
    department: "Imagerie",
    position: "Manipulatrice radio",
    status: "ACTIVE",
  },
  {
    id: "demo-staff-6",
    firstName: "Eric",
    lastName: "Ngoy",
    email: "eric.ngoy@hospitol.demo",
    department: "Administration",
    position: "Agent accueil",
    status: "ACTIVE",
  },
];
